var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback-button"},[_vm._v("Feedback geben")])
}
var staticRenderFns = []

export { render, staticRenderFns }